import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-data",
  "use": "icon-data-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-data\"><defs><style></style></defs><path d=\"M454.656 481.792L273.92 656.384l-57.344-55.296L454.656 371.2l196.608 189.952 221.184-215.04 57.344 55.296-278.528 270.848-196.608-190.464zM66.56 151.552h80.896v664.576h810.496v78.336H66.56V151.552z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol